import { render, staticRenderFns } from "./SetsIndex.vue?vue&type=template&id=0322506a&"
import script from "./SetsIndex.vue?vue&type=script&lang=js&"
export * from "./SetsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports